import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { ImportContainer } from 'app/Model/dataProcess/importContainer';
import { Catalog } from 'app/Model/Catalog/Catalog';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { LoginService } from 'app/Services/login.service';

@Component({
  selector: 'np-inspect-container-catalog',
  templateUrl: './inspect-container-catalog.component.html',
  styleUrls: ['./inspect-container-catalog.component.css']
})
export class InspectContainerCatalogComponent implements OnInit, OnChanges {

  @Input() container: ImportContainer | null = null;
  @Input() catalogId: string | null = null;
  @Input() dataSource: any | null = null;

  @Output() containerSaved = new EventEmitter<ImportContainer>();

  catalog: Catalog | null = null;

  isLoading = false;
  hasError = false;
  editVisible = false;

  constructor(
    private readonly catalogService: CatalogService,
    private readonly loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.loadCatalog();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['catalogId']) {
      this.loadCatalog();
    }
  }

  private loadCatalog(): void {
    const id = this.catalogId;
    const customerId = this.loginService?.currentUser?.customerId;

    if (!id || !customerId) {
      this.catalog = null;
      this.isLoading = false;
      this.hasError = false;
      return;
    }

    this.isLoading = true;
    this.hasError = false;

    this.catalogService.getCatalogNoSet(id, customerId).subscribe({
      next: (c: Catalog) => {
        this.catalog = c;
        this.isLoading = false;
        this.catalogService.selectedCatalogId = c.id;
        this.catalogService.catalog = c;
      },
      error: () => {
        this.catalog = null;
        this.isLoading = false;
        this.hasError = true;
      }
    });
  }

  openMetadataDialog(): void {
    if (!this.catalog) {
      return;
    }
    this.editVisible = true;
  }

  onMetadataSaved(updated: Catalog): void {
    this.catalog = updated;
    this.editVisible = false;
    if (this.container) {
      this.containerSaved.emit(this.container);
    }
  }

  onMetadataCanceled(): void {
    this.editVisible = false;
  }
}
